<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_patient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.diagnosis')"
            v-model.trim="data.diagnosis"
            required
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditPatient",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        name: null,
        diagnosis: null,
        phone: null,
      },
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async getDataToEdit() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `patients/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Patient || {};
        this.data.name = item.name;
        this.data.diagnosis = item.diagnosis;
        this.data.phone = item.phone;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load patient"
        );
      }
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("name", this.data.name || "");
      REQUEST_DATA.append("diagnosis", this.data.diagnosis || "");
      REQUEST_DATA.append("phone", this.data.phone || "");
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `patients/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/patients/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to edit patient"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.getDataToEdit();
  },
};
</script>
